/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { ProductListStoreAssignment } from './ProductListStoreAssignment';
// @ts-ignore
import {
// @ts-ignore
    ProductListStoreAssignmentFromJSON,
// @ts-ignore
    ProductListStoreAssignmentFromJSONTyped,
// @ts-ignore
    ProductListStoreAssignmentToJSON,
} from './ProductListStoreAssignment';

/**
 * 
 * @export
 * @interface ProductListStoreAssignmentListResponse
 */
export interface ProductListStoreAssignmentListResponse {
    /**
     * 
     * @type {number}
     * @memberof ProductListStoreAssignmentListResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductListStoreAssignmentListResponse
     */
    estimatedTotalCount: number;
    /**
     * 
     * @type {Array<ProductListStoreAssignment>}
     * @memberof ProductListStoreAssignmentListResponse
     */
    items: Array<ProductListStoreAssignment>;
}

/**
 * Check if a given object implements the ProductListStoreAssignmentListResponse interface.
 */
// @ts-ignore
export function instanceOfProductListStoreAssignmentListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimatedTotalCount" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

// @ts-ignore
export function ProductListStoreAssignmentListResponseFromJSON(json: any): ProductListStoreAssignmentListResponse {
    return ProductListStoreAssignmentListResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function ProductListStoreAssignmentListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductListStoreAssignmentListResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'estimatedTotalCount': json['estimated_total_count'],
        'items': ((json['items'] as Array<any>).map(ProductListStoreAssignmentFromJSON)),
    };
}

// @ts-ignore
export function ProductListStoreAssignmentListResponseToJSON(value?: ProductListStoreAssignmentListResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'estimated_total_count': value.estimatedTotalCount,
        'items': ((value.items as Array<any>).map(ProductListStoreAssignmentToJSON)),
    };
}

